import { useIntl } from "react-intl";

import { queries } from "lib/build/dashboards/ktx/queries";
import { Origin } from "lib/build/events";

import { useLastEventByQuery } from "src/features/events";
import { yesNoMessages } from "src/messages/generic";

export function useHt(): {
	value: string;
	timestamp?: string;
	origin?: Origin;
} {
	const primaryEvent = useLastEventByQuery<string>(
		queries.primaryHypertension
	);
	const secondaryEvent = useLastEventByQuery<string>(
		queries.secondaryHypertension
	);

	const { formatMessage } = useIntl();

	if (primaryEvent === undefined && secondaryEvent === undefined) {
		return { value: "-" };
	}

	return {
		value: formatMessage(yesNoMessages.YES),
		timestamp: primaryEvent
			? primaryEvent.timestamp
			: secondaryEvent?.timestamp,
		origin: primaryEvent ? primaryEvent.origin : secondaryEvent?.origin
	};
}
